<!--
 * @Descripttion: 
 * @Author: esther
 * @Date: 2023-02-14 10:39:01
-->
<template>
  <div class="box">
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm" width="200">
      <el-form-item prop="mobile">
        <el-input disabled autocomplete="off" maxLength="11" v-model="ruleForm.mobile" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input style="width: 220px;float: left;" maxLength="4" name="code" type="text" v-model="ruleForm.code" autocomplete="off"
          placeholder="请输入验证码" />
        <el-button type="hnc" v-show="codeTime" @click="getCaptcha" class="r codeBtn">发送验证码</el-button>
        <el-button type="disabled" v-show="!codeTime" class="r codeBtn gray">{{countTime}}s</el-button>
      </el-form-item>
      <el-form-item prop="pwd">
        <el-input type="password" @keyup.enter.native="resetPwd" v-model="ruleForm.pwd" autocomplete="new-password"
						placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item prop="checkPwd">
        <el-input type="password" v-model="ruleForm.checkPwd" placeholder="请再次输入密码"></el-input>
      </el-form-item>
      <el-form-item style="margin-top: 30px;">
        <el-button type="hnc big" style="width:100%;" :loading="loading" @click.native.prevent="pwdResetSubmit('ruleForm')">
          提交
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button style="width:100%;" @click="pwdResetSubmit">
          取消
        </el-button>
      </el-form-item>
    </el-form>
		<Captcha :showCaptcha="isShow" @captcha="captcha" />
  </div>
</template>
<script>
import apiData from "@/config/api";
import http from "@/config/httpConfig";
import Captcha from '@/components/Captcha.vue'
export default {
  name: "Password",
  props: {
    mobile: String,
    showDialog: {
      type: Boolean,
      default: false, //定义参数默认值
    },
  },
  components: {
    Captcha
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value.length < 11) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    const validateCode = (rule, value, callback) => {
      if (value.length < 4) {
        callback(new Error('请输入正确的验证码'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不少于6位，支持数字、字母、字符'))
      } else {
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        console.log(this.ruleForm)
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      countTime: '',
      codeTime: true,//倒计时
      timer: null,
      isShow: false,
      ruleForm: {
        mobile: '',
        code: '',
        pwd: '',
        checkPwd: ''
      },
      rules: {
        mobile: [
          {
            required: true,
            trigger: 'blur',
            validator: validateUsername
          }
        ],
        code: [
          {
            required: true,
            trigger: 'blur',
            validator: validateCode
          }
        ],
        pwd: [
          { required: true, trigger: 'blur', validator: validatePass }
        ],
        checkPwd: [
          { required: true, trigger: 'blur', validator: validatePass2 }
        ],
      }
    };
  },
  mounted() {
    this.ruleForm.mobile = this.mobile
  },
  methods: {
    captcha(captcha){
      // this.isShow = false
      this.getCode(captcha)
    },
    onSubmit() {
      console.log('submit!');
    },
    codeTimer(){
      const TIME_COUNT = 120;
      if (!this.timer) {
        this.countTime = TIME_COUNT;
        this.codeTime = false;
        this.timer = setInterval(() => {
        if (this.countTime > 0 && this.countTime <= TIME_COUNT) {
          this.countTime--;
          } else {
          this.codeTime = true;
          clearInterval(this.timer);
          this.timer = null;
          }
        }, 1000)
      }
    },
    // 获取验证码
    getCode(captcha) {
      let _this = this
      let params = {
        mobile: this.ruleForm.mobile,
        // captcha: captcha
      }
      // _this.codeTimer()
      //     _this.$message({
      //       message: '发送成功！',
      //       type: 'success'
      //     });
      //     return
      http.post(apiData.pwdCode, true, params, function (res) {
        if (res.data.code == 200) {
          _this.codeTimer()
          _this.$message({
            message: '发送成功！',
            type: 'success'
          });
        }
      })
    },
    pwdResetSubmit(formName){
      let that = this
      let params = that.ruleForm
      if (formName && formName == 'ruleForm') {//确定
        that.$refs[formName].validate((valid) => {
          if (valid) {
            http.post(apiData.pwdReset, true, params, function (res) {
              if (res.data.code == 200) {
                let data = res.data.obj
                that.$message({
                  message: '设置成功！',
                  type: 'success'
                });
                //退出登录，重新登录一下
                window.location.href = '/common/organizationstructure/skip/logout'
              }
            })
          } else {
            return
          }
        });
      } else {
        this.$emit('changeShowDialog', false)
      }
      // that.showDialog = false
    },
    getCaptcha() {
      let _this = this
      let mobile = this.ruleForm.mobile || ''
      if(mobile.length !== 11){
        this.$message({
          message: '请输入正确的手机号！',
          type: 'warning'
        });
        return
      } else {
        // debugger
        _this.captcha()
        // this.isShow = true
      }
    },
    pwdReset() {
      let _this = this
      http.post(apiData.verificationImagCheck, true, params, function (res) {
        if (res.data.code == 200) {
          let data = res.data.obj
          _this.$message({
            message: '设置成功！',
            type: 'success'
          });
          _this.$router.replace('/login')
        }
      })
    },
  }
};
</script>
<style lang="less">
.box {
  width: 360px;
  margin: 0 auto 0 auto;
  .el-form-item {
    margin-bottom: 22px;
    .el-form-item__error {
      padding-top: 6px;
    }
  }
}
.codeBtn {
  width: 112px;
}

</style>